module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.registered) ? _c('section', [_c('div', {
    staticClass: "add-device"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', [_c('form', {
    attrs: {
      "id": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.registerDevice($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control",
    class: {
      error: _vm.$v.name.$error, valid: _vm.$v.name.$dirty && !_vm.$v.name.$invalid
    },
    attrs: {
      "type": "text",
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }, _vm.$v.name.$touch]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    class: {
      error: _vm.$v.email.$error, valid: _vm.$v.email.$dirty && !_vm.$v.email.$invalid
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }, _vm.$v.email.$touch]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "phone no"
    }
  }, [_vm._v("Phone No")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "form-control",
    class: {
      error: _vm.$v.phone.$error, valid: _vm.$v.phone.$dirty && !_vm.$v.phone.$invalid
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }, _vm.$v.phone.$touch]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group device-type"
  }, [_c('label', {
    attrs: {
      "for": "device type"
    }
  }, [_vm._v("\n            Device Type\n          ")]), _vm._v(" "), _c('label', {
    staticClass: "male-radio  control control--radio radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deviceType),
      expression: "deviceType"
    }],
    staticClass: "radio-btn",
    attrs: {
      "name": "optionsRadios",
      "id": "#",
      "value": "option1",
      "checked": "checked",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.deviceType, "option1")
    },
    on: {
      "__c": function($event) {
        _vm.deviceType = "option1"
      }
    }
  }), _vm._v("Origins Laser Egg\n            "), _c('div', {
    staticClass: "control__indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "male-radio control control--radio radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deviceType),
      expression: "deviceType"
    }],
    staticClass: "radio-btn",
    attrs: {
      "name": "optionsRadios",
      "id": "#",
      "value": "option2",
      "checked": "checked",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.deviceType, "option2")
    },
    on: {
      "__c": function($event) {
        _vm.deviceType = "option2"
      }
    }
  }), _vm._v("AirVisual Node\n            "), _c('div', {
    staticClass: "control__indicator"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "device id"
    }
  }, [_vm._v("Device Id")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deviceId),
      expression: "deviceId"
    }],
    staticClass: "form-control",
    class: {
      error: _vm.$v.deviceId.$error, valid: _vm.$v.deviceId.$dirty && !_vm.$v.deviceId.$invalid
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.deviceId)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.deviceId = $event.target.value
      }, _vm.$v.deviceId.$touch]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "device location"
    }
  }, [_vm._v("GPS Coordinates")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address),
      expression: "address"
    }],
    staticClass: "form-control",
    class: {
      error: _vm.$v.address.$error, valid: _vm.$v.address.$dirty && !_vm.$v.address.$invalid
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.address)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.address = $event.target.value
      }, _vm.$v.address.$touch]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "Height of Device"
    }
  }, [_vm._v("Height of Device")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.height_of_device),
      expression: "height_of_device"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.height_of_device)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.height_of_device = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default device-btn",
    attrs: {
      "type": "submit",
      "disabled": _vm.$v.$invalid
    }
  }, [_vm._v("Register Device")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [(_vm.errors.length > 0) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('strong', [_vm._v("Whoops!")]), _vm._v(" " + _vm._s(_vm.inputError)), _c('br'), _c('br'), _vm._v(" "), _c('ul', _vm._l((_vm.errors), function(error) {
    return _c('li', [_vm._v("\n                  " + _vm._s(error) + "\n              ")])
  }))]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.registered) ? _c('section', {
    staticClass: "bg-color"
  }, [_vm._m(3)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Name"), _c('span', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email"), _c('span', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "image"
    }
  }, [_vm._v("Image")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "id": "file"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "error-content"
  }, [_c('h2', [_vm._v("Success")]), _vm._v(" "), _c('p', [_vm._v("Your Device was successfully registered! We will contact you soon..")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ae09f85"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Register.vue
// module id = 297
// module chunks = 1